import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Esto es para principiantes o necesito experiencia previa?',
    answer: 'No necesitás experiencia. Está pensado para empezar desde cero con explicaciones claras y paso a paso.'
  }, {
    question: '¿Y si ya intenté aprender crochet y no me salió?',
    answer: 'Este método es para vos. El problema no eras vos, sino cómo te lo explicaban.'
  }, {
    question: '¿En qué formato está el ebook y cómo lo recibo?',
    answer: 'Es digital (PDF). Lo recibís al instante y podés verlo desde cualquier dispositivo.'
  }, {
    question: '¿Cuánto tiempo me va a llevar ver resultados?',
    answer: 'Desde el primer día podés empezar. Muchas alumnas logran resultados en pocos días.'
  }, {
    question: '¿Incluye ideas que realmente se puedan vender?',
    answer: 'Sí. Incluye diseños pensados para generar ingresos desde casa.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 7 días de garantía. Te devolvemos el 100% del dinero.'
  }, {
    question: '¿Necesito materiales costosos?',
    answer: 'No. Podés empezar con materiales básicos y accesibles.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-16 px-4 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-26">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} className="bg-cream rounded-2xl overflow-hidden shadow-md" data-id="element-28">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-cream/80 transition-colors" aria-expanded={openIndex === index} data-id="element-29">
                <h3 className="font-heading font-semibold text-lg md:text-xl text-gray-900 pr-4" data-id="element-30">
                  {faq.question}
                </h3>
                <ChevronDownIcon className={`w-6 h-6 text-primary flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} aria-hidden="true" data-id="element-31" />
              </button>

              {openIndex === index && <div className="px-6 pb-6" data-id="element-32">
                  <p className="font-body text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-33">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}